<!--
Este componente recibe como parametros las varibles de control de visibilidad de
las flechas de avanzar y retroceder (atrasVisible y adelanteVisible). También recibe los diálogoa reproducir.
El componente automáticamente actualiza el texto (currentText) y devuelve el nuevo valor
a través de la función :update:currentText para notificar al padre.

NOTA: Se asume que los diálogos siempre van a empezar en el diálogo 0
-->
<template>
<v-layout row>
  <v-flex class="dialogos">
    <v-layout row align-center class="wrap-md-and-down">
      <v-flex text-xs-center class="personaje" v-if="personaje">
        <img src="../assets/imagenes_compartidas/personaje.png">
      </v-flex>
      <v-flex xs12 class="white" :class="personaje?'apply-padding-left':''">
        <v-layout row align-center>
          <div v-show="atrasVisible && currentText>0" class="flecha-atras diagnav hvr-scale" @click="atras"></div>
          <v-flex>
            <p v-show="currentText == idx" v-for="(dialogo,idx) in dialogos" :key="'key'+idx" :id="'diag-'+idx"><span v-html="dialogo"></span></p>
          </v-flex>
          <div v-show="adelanteVisible && currentText < dialogos.length - 1" class="flecha-adelante diagnav hvr-scale" @click="adelante"></div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</v-layout>
</template>

<script>
export default {
  props: {
    atrasVisible: {
      type: Boolean,
      default: true
    },
    adelanteVisible:  {
      type: Boolean,
      default: true
    },
    dialogos: {
      type: Array,
      required: true
    },
    personaje: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      imgInstructor: '',
      currentText: 0
    }
  },
  created() {
    var self = this
  },
  methods:{
    atras() {
      this.currentText--
      this.$emit('update:currentText', this.currentText)
    },
    adelante(){
      this.currentText++
      this.$emit('update:currentText', this.currentText)
    },
    saltarAlDialogo(numeroDialogo){
      this.currentText = numeroDialogo
      this.$emit('update:currentText', this.currentText)
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../sass/globals';
.white {
  border: 1px solid $azul !important;
}
.dialogos{
  color: black;
  p {
    margin: 0;
  }
  margin-bottom: 10px;
}

.personaje{
  position: relative;
  flex-basis: 100px;
  img {
    width: 100px;
  }
  // Mantener la imagen a la izquierda si la pantalla es tablet horizontal o mayor
  @media (min-width: 960px){
    left: 50px;
  }
  // De lo contrrio mantenerla arriba
  @media (max-width: 960px){
    top: 50px;
  }
}

.white {
  padding: 20px;
  // padding-left: 70px;
}

.diagnav{
  width: 25px;
  min-width: 25px;
  height: 25px;
  cursor: pointer;
  right: 2px;
  top: 40%;
  color: black;
  background-image: url('../assets/imagenes_compartidas/nav-dialog.png');
  background-repeat: no-repeat;
}
/* nav-dialog.png es un contiene ambas flechas, con la propiedad background-position
   se elige la flecha adecuada
*/
.flecha-atras{
  background-position-x: 0;
  margin-right: 10px;
}

.flecha-adelante{
  background-position-x: -25px;
  margin-right: 10px;
}

.apply-padding-left {
  @media (min-width: 960px){
    padding-left: 65px;
  }  
  @media (max-width: 960px){
    padding-top: 65px;
  }
}
</style>
